import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const generatePdf = async (element, fileName = "Deposit-Slip.pdf") => {
  if (!element) return;

  const clone = element.cloneNode(true);

  clone.classList.add("pdf-mode");

  clone.style.width = "1600px";          
  clone.style.position = "absolute";
  clone.style.left = "-9999px";
  clone.style.top = "0";
  clone.style.background = "#fff";

  document.body.appendChild(clone);

  try {
    const canvas = await html2canvas(clone, {
      scale: 2,              
      useCORS: true,
      scrollX: 0,
      scrollY: 0,
      windowWidth: 1600,     
      windowHeight: clone.scrollHeight
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("portrait", "mm", "a4");

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position -= pageHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save(fileName);
  } finally {
    document.body.removeChild(clone);
  }
};
